import { useGameStore } from '@/store/gameStore';

export const useScoreSave = () => {
  const saveState = useGameStore((s) => s.saveState);
  const pendingSavePayload = useGameStore((s) => s.pendingSavePayload);
  const savedScore = useGameStore((s) => s.savedScore);

  return {
    saveState,
    hasPendingSave: !!pendingSavePayload,
    pendingScore: savedScore ?? pendingSavePayload?.finalScore ?? null,
  };
};
